import Vue from 'vue'
export default {
  set (state, { key, value }) {
    Vue.set(state, key, value)
  }
}
